import type { PrizeWheelSegmentData } from "./types";

export const PRIZE_SEGMENT_ORDER = [
  "meta quest 3",
  "1 imx",
  "10 gems",
  "$25 xbox",
  "playstation 5",
  "10 imx",
  "100 gems",
  "$20 steam",
  "50 imx",
  "50 gems",
  "series x",
  "5 imx",
  "5 gems",
  "$20 playstation",
  "switch 2",
  "500 gems",
  "$20 apple",
  "20 gems",
];

export const PRIZE_IMAGE_MAP = {
  "meta quest 3": "/icons/prize-wheel/meta-quest.webp",
  "playstation 5": "/icons/prize-wheel/hardware-ps5.webp",
  "series x": "/icons/prize-wheel/hardware-xbox.webp",
  "switch 2": "/icons/prize-wheel/hardware-switch.webp",
  "$20 steam": "/icons/prize-wheel/steam-card.webp",
  "$25 xbox": "/icons/prize-wheel/xbox-card.webp",
  "$20 playstation": "/icons/prize-wheel/ps-card.webp",
  "$20 apple": "/icons/prize-wheel/apple-card.webp",
  "50 imx": "/icons/prize-wheel/large-imx.webp",
  "10 imx": "/icons/prize-wheel/medium-imx.webp",
  "5 imx": "/icons/prize-wheel/small-imx.webp",
  "1 imx": "/icons/prize-wheel/small-imx.webp",
  "500 gems": "/icons/prize-wheel/large-gems.webp",
  "100 gems": "/icons/prize-wheel/large-gems.webp",
  "50 gems": "/icons/prize-wheel/medium-gems.webp",
  "20 gems": "/icons/prize-wheel/small-gems.webp",
  "10 gems": "/icons/prize-wheel/small-gems.webp",
  "5 gems": "/icons/prize-wheel/generic-gem.webp",
  "gift card": "/icons/prize-wheel/gift-card.webp",
};

export const mapTierToSegmentColour = (
  tier: number,
): "yellow" | "purple" | "blue" | "green" | "grey" => {
  switch (tier) {
    case 1:
      return "yellow";
    case 2:
      return "purple";
    case 3:
      return "blue";
    case 4:
      return "green";
    case 5:
      return "grey";
    default:
      return "grey";
  }
};

export const getTierName = (tier: PrizeWheelSegmentData["tier"]) => {
  switch (tier) {
    case "grey":
      return "Common Prize";
    case "green":
      return "Uncommon Prize";
    case "blue":
      return "Rare Prize";
    case "purple":
      return "Epic Prize";
    case "yellow":
      return "Legendary Prize";
    default:
      return "Prize";
  }
};

export const getTierOverlayColor = (tier: PrizeWheelSegmentData["tier"]) => {
  switch (tier) {
    case "yellow":
      return "#FFD700";
    case "purple":
      return "#9c2dff";
    case "blue":
      return "#46acff";
    case "green":
      return "#3cd25b";
    case "grey":
      return "#6d6c6d";
    default:
      return "#2563eb";
  }
};

export const getPrizeClaimCopy = (
  tier: PrizeWheelSegmentData["tier"],
  label: PrizeWheelSegmentData["label"],
) => {
  switch (tier) {
    case "yellow":
    case "purple": {
      if (label.toLowerCase().includes("imx")) {
        return "IMX WILL BE DISTRIBUTED AUTOMATICALLY TO YOUR WALLET";
      }
      return "WE WILL SOON SEND INSTRUCTIONS TO YOUR PASSPORT EMAIL TO CLAIM YOUR PRIZE";
    }
    case "green":
    case "grey":
      return "GEMS WILL BE DISTRIBUTED AUTOMATICALLY TO YOUR WALLET";
    case "blue":
      return "IMX WILL BE DISTRIBUTED AUTOMATICALLY TO YOUR WALLET";
    default:
      return "";
  }
};
